import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {I_List} from "@/types/iList";
import {date} from "quasar";
import Nomenclatures from "@/module/store/nomenclatures"
import {iNomTypesOfEvents} from '@/types/iNomTypesOfEvents';

import EditGiftForList from "@/components/EditGiftForList/EditGiftForList"
import EditPartakerForList from "@/components/EditPartakerForList/EditPartakerForList"
import EditImageForList from "@/components/EditImageForList/EditImageForList";

interface I_AjaxResponse_GetMyLists{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        lists: Array<I_List>
    }
}

@Component({components:{EditGiftForList,EditPartakerForList,EditImageForList}})
export default class MyHomePage extends Vue {
    isAjaxLoadingLists:boolean=false;
    myBoolTrue:boolean=true;
    myLists:Array<I_List>=[];
    dialogAddChildToList:boolean=false;
    currentChildComponent:string='';
    sizelg:string='lg';
    sizemd:string='md';
    resetSlideItem:any;
    list_to_edit:I_List={
        userid:0,
        listid:0,
        list_name:'',
        contact_phone:'',
        name_of_titular_event:'',
        type_of_event:0,
        event_time:'',
        event_time_data:'',
        event_time_ora:'',
        privacy_type:'',
        password_list:'',
        description:'',
        location_county:'',
        location_city:'',
        location_street:'',
        location_text:'',
        type_of_titular_event:'',
        status:'',
        url_for_img:'',
        has_attached_image:'',
        token_pt_acces_lista:''
    }

    $refs:any;
    private userStore=getModule(User);
    private nomenclaturesStore=getModule(Nomenclatures);

    async getMyLists(){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_GetMyLists>> axios.get(`${CONFIG_ENV.URL_GIFTS.get_lists}`);
        return res;
    }


    constructor(){
        super();
    }

    onLeftOrRight (parmas:any) {
        this.resetSlideItem=parmas;
    }

    tryToResetSlideItem(){
        this.resetSlideItem.reset();
    }

    tryToOpenList(plistid:number){
        this.$router.push({ name: 'works_a_list', params: { m:'e', listid: plistid.toString() } })
    }

    eventFire(el:any, etype:any){
        if (el.fireEvent) {
            el.fireEvent('on' + etype);
        } else {
            var evObj = document.createEvent('Events');
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
        }
    }
    sendTouchEvent(x:any, y:any, element:any, eventType:any) {
        const touchObj = new Touch({
            identifier: Date.now(),
            target: element,
            clientX: x,
            clientY: y,
            radiusX: 2.5,
            radiusY: 2.5,
            rotationAngle: 10,
            force: 1,
        });

        const touchEvent = new TouchEvent(eventType, {
            cancelable: true,
            bubbles: true,
            touches: [touchObj],
            targetTouches: [],
            changedTouches: [touchObj],
            shiftKey: true,
        });

        element.dispatchEvent(touchEvent);
    }

    getAwesomeIconForEventType(ptype_id:number):string{
        let event_type=this.nomenclaturesStore.nom_types_of_events.find((pevent_type:iNomTypesOfEvents)=>{
            return pevent_type.type_id==ptype_id
        })
        if(event_type){
            return event_type.icon_awesome;
        }else return '';
    }

    simulateTouch(){
        const vueInst=this;
        const myElement = document.getElementById('myDivId1');
        if(myElement) {
            vueInst.eventFire(myElement, 'click');
            //var rect = myElement.getBoundingClientRect();
            //console.log(rect.top, rect.right, rect.bottom, rect.left);
            //vueInst.sendTouchEvent(0, 0, myElement, 'touchstart');
            //vueInst.sendTouchEvent(120, 270, myElement, 'touchmove');
            //vueInst.sendTouchEvent(120, 270, myElement, 'touchend');
            //console.log('si gata!')
        }

        var mouseMoveEvent = document.createEvent("MouseEvents");

        mouseMoveEvent.initMouseEvent(
            "mousemove", //event type : click, mousedown, mouseup, mouseover, mousemove, mouseout.
            true, //canBubble
            false, //cancelable
            window, //event's AbstractView : should be window
            1, // detail : Event's mouse click count
            50, // screenX
            50, // screenY
            50, // clientX
            50, // clientY
            false, // ctrlKey
            false, // altKey
            false, // shiftKey
            false, // metaKey
            0, // button : 0 = click, 1 = middle button, 2 = right button
            null // relatedTarget : Only used with some event types (e.g. mouseover and mouseout). In other cases, pass null.
        );

        document.dispatchEvent(mouseMoveEvent)
    }

    tryToOpenAddNewGiftForm(plist:I_List){
        this.list_to_edit=plist;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditGiftForList';
    }

    tryToOpenAddNewGiftFormAndResetSlideItem(plist:I_List){
        this.list_to_edit=plist;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditGiftForList';
        this.resetSlideItem.reset();
    }

    tryToOpenAddNewPartakerFormAndResetSlideItem(plist:I_List){
        this.list_to_edit=plist;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditPartakerForList';
        this.resetSlideItem.reset();
    }

    tryToOpenAddNewPartakerForm(plist:I_List){
        this.list_to_edit=plist;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditPartakerForList';
    }

    tryToOpenFormAddNewImageToList(plist:I_List){
        this.list_to_edit=plist;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditImageForList';
    }

    fctInParentforActionInGift(info_from_child_comanda:string) {
        var vueInst = this;
        vueInst.$q.loading.hide();
        switch (info_from_child_comanda){
            case 'GIFT_SAVED':vueInst.dialogAddChildToList=false;break;
            case 'PARTAKER_SAVED':vueInst.dialogAddChildToList=false;break;
            case 'AnImageForListWasUploaded':vueInst.list_to_edit.has_attached_image='y';
                                            vueInst.list_to_edit.url_for_img=CONFIG_ENV.URL_LISTS.getImageAsAvatarForList+'/'+vueInst.list_to_edit.listid+'?t='+Math.random();
                                            this.dialogAddChildToList=false;
                                            break;
        }
    }

    activated(){
        //console.log('%cactivated my_home_page','color:orange; font-size:20px;');
        const vueInst=this;
        vueInst.isAjaxLoadingLists=true;
        vueInst.getMyLists().then((presponse:I_AjaxResponse_GetMyLists)=>{
            vueInst.isAjaxLoadingLists=false;
            vueInst.myLists=[];
            if(presponse.data.status=='success'){
                presponse.data.lists.forEach((plist: any)=>{
                    let eventDate = date.buildDate({ year:plist.event_time.substr(0, 4),
                                                    month:plist.event_time.substr(5, 2),
                                                    date:plist.event_time.substr(8, 2),
                                                    hours:plist.event_time.substr(11, 2),
                                                    minutes:plist.event_time.substr(14, 2)
                                                });

                    vueInst.myLists.push({
                                            userid:plist.userid,
                                            listid:plist.listid,
                                            list_name:plist.list_name,
                                            contact_phone:plist.contact_phone,
                                            name_of_titular_event:plist.name_of_titular_event,
                                            type_of_event:plist.type_of_event,
                                            event_time:plist.event_time,
                                            event_time_data:date.formatDate(eventDate, 'DDMMM,YYYY'),
                                            event_time_ora:date.formatDate(eventDate, 'HH:mm'),
                                            privacy_type:plist.privacy_type,
                                            password_list:plist.password_list,
                                            description:plist.description,
                                            location_county:plist.location_county,
                                            location_city:plist.location_city,
                                            location_street:plist.location_street,
                                            location_text:plist.location_text,
                                            type_of_titular_event:plist.type_of_titular_event,
                                            status:plist.status,
                                            has_attached_image:plist.has_attached_image,
                                            url_for_img:CONFIG_ENV.URL_LISTS.getImageAsAvatarForList+'/'+plist.listid,
                                            token_pt_acces_lista:''
                                        });
                                    })
                        }
                else{
                vueInst.$q.notify({
                                        color: 'red',
                                        textColor: 'white',
                                        position:'top-right',
                                        timeout: 3000,
                                        icon: 'fas fa-exclamation-triangle',
                                        message: presponse.data.message
                                    });
                    }
            });
    }
}
